import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
/*
import { getApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
*/

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  //databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  //storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGE_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  //measurementId: process.env.
};

firebase.initializeApp(firebaseConfig);

//connectAuthEmulator(getAuth(), "http://127.0.0.1:9099/");
//connectFunctionsEmulator(getFunctions(getApp()), "127.0.0.1", "5001");
export default firebase;